document.addEventListener("DOMContentLoaded", function () {
  const sections = document.getElementsByClassName('js-contact-section');
  const isActiveClass = "acc_is-active";
  if (sections) {
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      section.addEventListener('click', function (e) {
        const parent = section.parentNode;
        if (parent.classList.contains(isActiveClass)) {
          parent.classList.remove(isActiveClass);
        } else {
          parent.classList.add(isActiveClass);
        }
      });
    }
  }
});